module.exports = require('./zlib_bindings');
